export function getCollectorSetBrokers(accountSet) {
  const brokers = Array.isArray(accountSet?.brokers) ? accountSet.brokers : [];
  const brokerRows = brokers
    .map((broker, index) => {
      const brokerId = broker?.id || broker?._id || broker?.brokerId;
      if (!brokerId) return null;

      const brokerPosition = broker?.position || index + 1;
      const terminal = String(broker?.terminal || "")
        .trim()
        .toUpperCase();
      const baseLabel = String(
        broker?.brokerName ||
          broker?.name ||
          broker?.server ||
          terminal ||
          `Broker ${brokerPosition}`,
      ).trim();

      return {
        brokerId: String(brokerId),
        brokerPosition,
        terminal,
        baseLabel,
      };
    })
    .filter(Boolean);

  const labelCounts = brokerRows.reduce((counts, broker) => {
    const key = broker.baseLabel.toLowerCase();
    counts.set(key, (counts.get(key) || 0) + 1);
    return counts;
  }, new Map());

  return brokerRows.map((broker) => {
    const duplicateLabel = labelCounts.get(broker.baseLabel.toLowerCase()) > 1;
    const shouldAppendTerminal =
      duplicateLabel && broker.terminal && broker.baseLabel.toUpperCase() !== broker.terminal;

    return {
      brokerId: broker.brokerId,
      brokerPosition: broker.brokerPosition,
      terminal: broker.terminal,
      label: shouldAppendTerminal ? `${broker.baseLabel} ${broker.terminal}` : broker.baseLabel,
    };
  });
}

function normalizeCollectorSetFile(file) {
  if (
    !file ||
    file.content === undefined ||
    file.content === null ||
    String(file.content).length === 0
  ) {
    throw new Error("Collector set file content was not returned by the server.");
  }

  return {
    ...file,
    brokerId: file?.brokerId ? String(file.brokerId) : "",
    brokerKey: file?.brokerKey || "",
    brokerName: file?.brokerName || "",
    brokerPosition: file?.brokerPosition || null,
    server: file?.server || "",
    accountNumber: file?.accountNumber || "",
    password: file?.password || "",
    requestedSymbol: file?.requestedSymbol || "",
    terminal: String(file?.terminal || "")
      .trim()
      .toUpperCase(),
    filename: file?.filename || "",
    templateFilename: file?.templateFilename || "",
    suggestedFilename: file?.suggestedFilename || "",
    commentPrefix: file?.commentPrefix || "",
    content: String(file.content),
  };
}

export function normalizeCollectorSetFileResponse(payload) {
  const file = payload?.file || null;

  return {
    requestId: payload?.requestId || null,
    requestType: payload?.requestType || null,
    accountSet: payload?.accountSet || {},
    duplicateLoginDetected: Boolean(payload?.duplicateLoginDetected),
    warning: payload?.warning || null,
    file: normalizeCollectorSetFile(file),
  };
}

export function normalizeCollectorSetFilesResponse(payload) {
  const files = Array.isArray(payload?.files) ? payload.files : [];
  return {
    requestId: payload?.requestId || null,
    requestType: payload?.requestType || null,
    accountSet: payload?.accountSet || {},
    duplicateLoginDetected: Boolean(payload?.duplicateLoginDetected),
    warning: payload?.warning || null,
    files: files.map((file) => normalizeCollectorSetFile(file)),
  };
}

export function getCollectorSetDownloadFilename(file) {
  const filename = String(
    file?.suggestedFilename || file?.filename || file?.templateFilename || "",
  ).trim();
  if (!filename) {
    throw new Error("Download filename was not returned by the server.");
  }
  return filename;
}

function buildCollectorSetFileClipboardText(responses) {
  const files = (Array.isArray(responses) ? responses : []).map((payload) =>
    normalizeCollectorSetFileResponse(payload),
  );

  if (files.length === 0) {
    return "";
  }

  return files.map((payload) => payload.file.content).join("\n\n");
}

export function buildCollectorSetClipboardText(responses) {
  return buildCollectorSetFileClipboardText(responses);
}

export function buildCollectorSetSingleFileClipboardText(payload) {
  return buildCollectorSetFileClipboardText([payload]);
}
